module.exports = __webpack_public_path__ + "img/59_16.5b83e93b.png";